import { combineReducers } from 'redux';
import diagram from './diagram';
import main from './main';
import notify from './notify';

const rootReducer = combineReducers({
    diagram,
    main,
    notify,
});

export default rootReducer;
